// @flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import SendShareController from 'app/common/react/components/SendShareController/SendShareController';
import { IconButton } from 'gestalt';

type Props = {
  handleSendShareFlyoutButtonClick: () => void,
};
export const SendProfileButton = (props: Props) => (
  <div className="sendShareFlyoutButtonTest">
    <IconButton
      accessibilityLabel={i18n._(
        'Send Profile',
        'Accessible label for button to send this profile',
      )}
      onClick={props.handleSendShareFlyoutButtonClick}
      icon="share"
      size="lg"
    />
  </div>
);

export default SendShareController.makeSendShareButton(SendProfileButton);
